export class MaintenanceVehicleValuesOperations {
  "id": number;
  "description": string;
  "serviceType": string;
  "disclaimer": string;
}